// @flow

import isNumber from 'lodash.isnumber';
import isBoolean from 'lodash.isboolean';

import {tableCellName, HOVERED_CLASS} from './constants';
import {getPropertyClasses, getCells} from './utils';

import type {PropertyClasses} from './typedef';

type ToggleProps = {|
    shouldAddClass: boolean,
    id: number | string,
    rowIndex: number | string,
    rowTypes: PropertyClasses,
|};

export class DataTableHover {
    id: string;
    activeHoverIndexes: {|cell?: number | string, row: number | string, rowTypes: PropertyClasses |} | null;

    constructor(id: string) {
        this.id = id;
        this.activeHoverIndexes = null;
    }

    setRowHover = (rowIndex: number | string, rowTypes: PropertyClasses) => {
        this.removePrevHover();
        this.activeHoverIndexes = {row: rowIndex, rowTypes};
        this.toggleRowClasses(true, rowIndex, rowTypes);
    };

    removeRowHover = (rowIndex: number | string, rowTypes: PropertyClasses) => {
        this.toggleRowClasses(false, rowIndex, rowTypes);
    };

    toggleRowClasses = (shouldAddClass: boolean, rowIndex: number | string, rowTypes: PropertyClasses) => {
        const fixedRow = document.getElementById(`${this.id}${getPropertyClasses(rowTypes)}-row-${rowIndex}`);
        const row = document.getElementById(
            `${this.id}${getPropertyClasses({pinned: rowTypes.pinned})}-row-${rowIndex}`
        );
        this.toggleElementClass(fixedRow, shouldAddClass, HOVERED_CLASS);
        this.toggleElementClass(row, shouldAddClass, HOVERED_CLASS);
    };

    toggleElementClass = (el: ?Element, shouldAddClass: boolean, className: string) => {
        if (!el) {
            return;
        }
        if (shouldAddClass) {
            el.classList.add(className);
        } else {
            el.classList.remove(className);
        }
    };

    setCellHover = (id: ?number | ?string, rowIndex: number | string, rowTypes: PropertyClasses) => {
        if (typeof id === 'number' || typeof id === 'string') {
            if (!rowTypes.fixed) {
                this.removePrevHover();
            }
            this.activeHoverIndexes = {cell: id, row: rowIndex, rowTypes};
            this.toggleCellClasses({shouldAddClass: true, id, rowIndex, rowTypes});
        }
    };

    removeCellHover = (id: ?number | ?string, rowIndex: number | string, rowTypes: PropertyClasses) => {
        if (typeof id === 'number' || typeof id === 'string') {
            this.toggleCellClasses({shouldAddClass: false, id, rowIndex, rowTypes});
        }
    };

    toggleCellClasses = ({shouldAddClass, id, rowIndex, rowTypes}: ToggleProps) => {
        const pinnedClass = rowTypes.pinned ? '-pinned-' : '-';
        const nodeId = parseFloat(id);
        const header = rowTypes.fixed
            ? document.getElementById(`${this.id}-fixed-header-${nodeId}`)
            : document.getElementById(`${this.id}-header-${nodeId}`);
        const cells = getCells({tableId: this.id, rowIndex, nodeId, pinned: !!rowTypes.pinned});
        const fixedCell = document.getElementById(`${this.id}-fixed${pinnedClass}row-${rowIndex}`);

        this.toggleElementClass(header, shouldAddClass, `${tableCellName}_hovered`);
        this.toggleElementClass(cells?.prevCell, shouldAddClass, `${tableCellName}_bottom-hovered`);
        this.toggleElementClass(cells?.currentCell, shouldAddClass, `${tableCellName}_current-hovered`);
        this.toggleElementClass(fixedCell, shouldAddClass, HOVERED_CLASS);
    };

    removePrevHover = () => {
        const {row, cell, rowTypes} = this.activeHoverIndexes || {};

        if (isNumber(row)) {
            this.removeRowHover(row, rowTypes);
        }

        if (isNumber(row) && isNumber(cell) && isBoolean(rowTypes.pinned)) {
            this.removeCellHover(cell, row, rowTypes);
        }
    };
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
